/* eslint-disable @typescript-eslint/ban-types */
// eslint-disable-next-line no-restricted-imports
import i18n from "i18next";
// eslint-disable-next-line no-restricted-imports
import { initReactI18next } from "react-i18next";
import { languageFromNavigator } from "./languageFromNavigator";

export async function translationSetup(phrases: {}) {
  return i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources: {
        en: {
          translations: phrases,
        },
        ja: {
          translations: phrases,
        },
      },
      ...{
        ns: ["translations"],
        defaultNS: "translations",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        lng: await languageFromNavigator(),
      },
      fallbackLng: "en",
      interpolation: {
        escapeValue: false,
      },
    });
}
